import React, { useMemo } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect, renderTextField } from "../../../../Components/Forms/renders";
import SelectBox from "../../../../Components/Forms/selectbox";
import switcbutton from "../../../../Components/Forms/switch";

import PropTypes from "prop-types";

const EditKampeerplaatsen = ({ handleSubmit, sensoren, categorien, relais, veldkasten }) => {
  const requiredValidator = useMemo(() => required(), []);
  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <Field name="veldkast" validate={[required()]} type="input" options={veldkasten} inputvalue="_id" inputnaam="naam" component={SelectBox} label="Vul de veldkast van de plaats in" />

              <Field name="device_id" type="input" options={sensoren} inputvalue="_id" inputnaam="device_id" component={SelectBox} label="Vul de Sensor ID in" />
            </div>
          </div>
          <div className="pull-left submit">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Opslaan" />
          </div>
        </div>
      </form>
    </div>
  );
};

EditKampeerplaatsen.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const ReduxFormSensorEdit = reduxForm({
  form: "categorie_edit", // a unique identifier for this form
})(EditKampeerplaatsen);

const mapStateToProps = (state) => ({
  initialValues: state.standplaatsen.kampeerplaats, // pull initial values from account reducer
});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
